import { Component} from '@angular/core';

@Component({
    selector: 'campaign-attached-main',
    templateUrl: './campaign-attached-main.tmpl.html'
})

export class CampaignAttachedMain {
    editMode: boolean = null; 

    public setVal(val:boolean) {
        this.editMode = val;  
    }
}
  